module.exports = __webpack_public_path__ + "static/media/3CRV.b07a9742.png";